import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useStopEventInvitesState() {
  return useAppState();
}

export function useStopEventInvitesActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const inviteCode = urlParams.get('invite_code');
    const inviteEmail = urlParams.get('invite_email');

    dispatch((state) => ({
      ...state,
      stopEventInvites: {
        loading: true,
        pageMessage: "Loading...",
        inviteCode,
        inviteEmail,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({
      ...state,
      stopEventInvites: {
        ...state.stopEventInvites,
        loading: false,
        pageMessage: response.pageMessage || state.stopEventInvites?.pageMessage,
      },
      feedbackMessage: response.feedbackMessage || null,
      feedbackVariant: response.feedbackVariant || null,
    }));
  }

  function onError(feedback) {
    dispatch((state) => ({
      ...state,
      stopEventInvites: {
        ...state.stopEventInvites,
        loading: false,
        pageMessage: feedback.pageMessage || state.stopEventInvites?.pageMessage,
      },
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
  };
}
